<template>
  <div style="width: 100%">
    <el-tabs v-model="activeName">
      <el-tab-pane label="我的考试" name="first" style></el-tab-pane
    ></el-tabs>
    <div class="boxCell" v-for="(item, index) in list" :key="index">
      <a :href="item.url" target="_blank">
        <div style="display: flex; align-items: center; color: #333">
          <img
            style="width: 50px; height: 50px"
            src="@/assets/image/slogo.png"
            alt=""
          />
          <div
            style="padding: 5px 20px; flex: 1; display: flex; line-height: 40px"
          >
            <h2>{{ item.name }}</h2>
            <!-- <p style="margin-left: 10px">考试时间：2020-11-15</p> -->
          </div>
          <el-button type="primary"> 开始考试 </el-button>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "first",
      list: [
        { name: "底盘检验员考试", url: "http://cjsp.cheqianqiu.net/temporarilyExaminationPaper/18" },
        { name: "外检员考试", url: "http://cjsp.cheqianqiu.net/temporarilyExaminationPaper/19" },
        { name: "引车员考试", url: "http://cjsp.cheqianqiu.net/temporarilyExaminationPaper/20" },
        { name: "网管员考试", url: "http://cjsp.cheqianqiu.net/temporarilyExaminationPaper/21" },
        { name: "登录员考试", url: "http://cjsp.cheqianqiu.net/temporarilyExaminationPaper/27" },
        {
          name: "技术负责人、授权签字人考试",
          url: "http://cjsp.cheqianqiu.net/temporarilyExaminationPaper/22",
        },
        {
          name: "质量负责人、内审员考试",
          url: "http://cjsp.cheqianqiu.net/temporarilyExaminationPaper/23",
        },
        { name: "设备维护员考试", url: "http://cjsp.cheqianqiu.net/temporarilyExaminationPaper/24" },
        { name: "OBD查验员考试", url: "http://cjsp.cheqianqiu.net/temporarilyExaminationPaper/25" },
        { name: "排放检验员考试", url: "http://cjsp.cheqianqiu.net/temporarilyExaminationPaper/26" },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.boxCell {
  margin: 10px auto 20px;

  border: 1px solid #e6e6e6;
  padding: 10px 20px;
  width: 700px;
}
</style>